import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CacheBuster } from 'ts-cacheable';
import { AnalyticList } from 'src/app/analytic/model/analyticList';
import { AnalyticEdit } from 'src/app/analytic/model/analyticEdit';

const analyticsCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class AnalyticService
{
  constructor(private http: HttpClient) { }

  /**
   * Delete a Analytic.
   *
   * @param id Analytic id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: analyticsCacheBuster
    })
  public deleteAnalytic(id: number): Observable<AnalyticList>
  {
    return this.http.delete<AnalyticList>(`/analytic/${id}`);
  }

  /**
   * Save a Analytic.
   *
   * @param data Analytic to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: analyticsCacheBuster
    })
  public saveAnalytic(data: any, isNew: boolean, analyticId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/analytic', data);
    }
    else
    {
      return this.http.put(`/analytic/${analyticId}`, data);
    }
  }

  /**
   * Get Analytic for grid list.
   */
  public getAnalyticList(): Observable<AnalyticList[]>
  {
    return this.http.get<AnalyticList[]>('/analytics/list');
  }

  /**
   * Get Analytic by id.
   *
   * @param id Analytic id
   */
  public getAnalyticById(id: number): Observable<AnalyticEdit>
  {
    return this.http.get<AnalyticEdit>(`/analytic/${id}`);
  }

  /**
   * Check if Analytic Name exists to avoid name duplicates
   *
   * @param name Analytic Name
   */
  public existsAnalyticName(name: string): Observable<any>
  {
    return this.http.get(`/analytic/exists?name=${name}`);
  }
}
